import { useState, useRef } from "react";

// ── UI Helpers ───────────────────────────────────────────────────
export const RG = ({ value, onChange, opts }) => (
  <div className="flex flex-wrap gap-1 justify-end">
    {opts.map(o => { const sel = value === o; const c = sel ? (o === "Correcto" || o === "Bueno" || o === "✓" || o === "✓ OK") ? "bg-green-500 text-white border-green-500" : (o === "Tuerto" || o === "Regular") ? "bg-yellow-400 text-white border-yellow-400" : "bg-red-500 text-white border-red-500" : "bg-white text-gray-500 border-gray-300"; return <button key={o} onClick={() => onChange(o)} className={`px-2 py-1 rounded-full text-xs font-semibold border ${c}`}>{o}</button>; })}
  </div>
);
export const Inp = ({ label, value, onChange, placeholder, type = "text" }) => (
  <div>{label && <label className="text-xs font-semibold text-gray-600 uppercase">{label}</label>}<input type={type} className="w-full border rounded-lg px-3 py-2 text-sm mt-1 focus:outline-none focus:ring-2 focus:ring-blue-400" placeholder={placeholder} value={value} onChange={e => onChange(e.target.value)} /></div>
);
export const Sel = ({ label, value, onChange, options }) => (
  <div>{label && <label className="text-xs font-semibold text-gray-600 uppercase">{label}</label>}<select className="w-full border rounded-lg px-3 py-2 text-sm mt-1 focus:outline-none focus:ring-2 focus:ring-blue-400" value={value} onChange={e => onChange(e.target.value)}>{options.map(o => <option key={o} value={o}>{o}</option>)}</select></div>
);
export const Btn = ({ onClick, disabled, children, color = "blue" }) => (
  <button onClick={onClick} disabled={disabled} className={`w-full bg-${color}-600 text-white font-bold py-3 rounded-xl hover:bg-${color}-700 disabled:opacity-40 transition-all`}>{children}</button>
);
export const CheckGrp = ({ title, color, items, setter, grupo }) => (
  <div className="border rounded-lg overflow-hidden">
    <div className={`px-3 py-2 ${color}`}><p className="text-xs font-bold uppercase">{title}</p></div>
    <div className="divide-y">{Object.keys(items).map(k => (
      <label key={k} className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-50">
        <input type="checkbox" checked={items[k]} className="w-4 h-4 accent-blue-500"
          onChange={() => setter(s => { const prev = s[grupo]; if (k === "TODO CORRECTO") return { ...s, [grupo]: { ...Object.fromEntries(Object.keys(prev).map(kk => [kk, false])), "TODO CORRECTO": !prev["TODO CORRECTO"] } }; const next = { ...prev, [k]: !prev[k] }; if (next[k]) next["TODO CORRECTO"] = false; return { ...s, [grupo]: next }; })} />
        <span className={`text-sm ${k === "TODO CORRECTO" ? "font-bold text-green-700" : "text-gray-700"}`}>{k}</span>
      </label>
    ))}</div>
  </div>
);
export const LogoSVG = ({ size = 20 }) => (
  <svg viewBox="0 0 64 64" width={size} height={size} fill="none">
    <path d="M8 28L32 10L56 28V56H8V28Z" stroke="white" strokeWidth="3" strokeLinejoin="round" fill="rgba(255,255,255,0.15)" />
    <circle cx="44" cy="18" r="9" fill="#22c55e" />
    <path d="M40 18l3 3 5-5" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export const CarretillaIconSVG = ({ size = 22 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2.5" y="11" width="9" height="6" rx="1" />
    <circle cx="5.5" cy="19" r="1.4" />
    <circle cx="9.5" cy="19" r="1.4" />
    <line x1="13" y1="6" x2="13" y2="17" />
    <line x1="15.5" y1="6" x2="15.5" y2="17" />
    <line x1="13" y1="14.5" x2="21" y2="14.5" />
    <line x1="13" y1="17" x2="21" y2="17" />
    <rect x="16.5" y="10" width="4" height="4.5" />
  </svg>
);
export const TranspaletaIconSVG = ({ size = 22 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <line x1="2.5" y1="15" x2="12.5" y2="15" />
    <line x1="2.5" y1="17.3" x2="12.5" y2="17.3" />
    <circle cx="4.5" cy="19.3" r="1.1" />
    <circle cx="10.5" cy="19.3" r="1.1" />
    <rect x="12.5" y="12.5" width="3" height="6.5" rx="1" />
    <line x1="15" y1="13" x2="20.5" y2="5" />
    <line x1="18.7" y1="6.3" x2="21.5" y2="4.3" />
  </svg>
);

// ── Sección de checklist con maestro "Todo correcto" (colapsa/despliega) ──
// value: { [item]: "Correcto"|"Incorrecto"|"No evaluado", "TODO CORRECTO": bool }
// Con conObservaciones=true, value: { [item]: { value, obs }, "TODO CORRECTO": bool }
export const ChecklistSeccion = ({ titulo, color = "bg-blue-50 text-blue-800", items, value, onChange, conObservaciones = false }) => {
  const todoCorrecto = value["TODO CORRECTO"] === true;
  const valorItem = (it) => conObservaciones ? (value[it]?.value || "") : (value[it] || "");

  const toggleTodoCorrecto = () => {
    if (todoCorrecto) {
      onChange({ ...value, "TODO CORRECTO": false });
    } else {
      const next = { "TODO CORRECTO": true };
      items.forEach(it => { next[it] = conObservaciones ? { ...(value[it] || {}), value: "Correcto" } : "Correcto"; });
      onChange(next);
    }
  };

  const cambiarItem = (item, val) => onChange({
    ...value,
    [item]: conObservaciones ? { ...(value[item] || {}), value: val } : val,
    "TODO CORRECTO": false,
  });

  const cambiarObs = (item, obs) => onChange({ ...value, [item]: { ...(value[item] || {}), obs } });

  return (
    <div className="border rounded-lg overflow-hidden">
      <label className={`flex items-center gap-3 px-3 py-2 cursor-pointer ${color}`}>
        <input type="checkbox" checked={todoCorrecto} onChange={toggleTodoCorrecto} className="w-4 h-4 accent-green-600" />
        <span className="text-xs font-bold uppercase">{titulo}{todoCorrecto ? " — ✅ Todo correcto" : ""}</span>
      </label>
      {!todoCorrecto && (
        <div className="divide-y">
          {items.map(it => (
            <div key={it} className="px-3 py-2 space-y-1.5">
              <div className="flex items-center justify-between gap-2">
                <span className="text-sm text-gray-700 flex-1">{it}</span>
                <RG value={valorItem(it)} onChange={v => cambiarItem(it, v)} opts={["Correcto", "Incorrecto", "No evaluado"]} />
              </div>
              {conObservaciones && (
                <input className="w-full border rounded-lg px-3 py-1.5 text-xs focus:outline-none focus:ring-2 focus:ring-blue-400" placeholder="Comentario..." value={value[it]?.obs || ""} onChange={e => cambiarObs(it, e.target.value)} />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// ── Vista de solo lectura para el PDF (plan FREE) ─────────────────
// html2canvas no reproduce bien los <input>/<select> nativos, así que
// el PDF captura esta vista estática en vez del formulario interactivo.
const BADGE_COLOR_PDF = { "Correcto": "bg-green-100 text-green-700", "Incorrecto": "bg-red-100 text-red-700" };

export const CampoPDF = ({ label, value }) => (
  <div>
    <p className="text-xs font-semibold text-gray-500 uppercase">{label}</p>
    <p className="text-sm text-gray-800 mt-0.5">{value || "—"}</p>
  </div>
);

export const ChecklistSeccionPDF = ({ titulo, color = "bg-blue-50 text-blue-800", items, value, conObservaciones = false }) => (
  <div className="border rounded-lg overflow-hidden">
    <div className={`px-3 py-2 ${color}`}><p className="text-xs font-bold uppercase">{titulo}</p></div>
    <div className="divide-y">
      {items.map(it => {
        const estado = (conObservaciones ? value[it]?.value : value[it]) || "No evaluado";
        const obs = conObservaciones ? value[it]?.obs : null;
        return (
          <div key={it} className="px-3 py-2 space-y-1">
            <div className="flex items-center justify-between gap-2">
              <span className="text-sm text-gray-700 flex-1">{it}</span>
              <span className={`text-xs font-semibold px-2 py-1 rounded-full whitespace-nowrap ${BADGE_COLOR_PDF[estado] || "bg-gray-100 text-gray-500"}`}>{estado}</span>
            </div>
            {obs && <p className="text-xs text-gray-500 italic">💬 {obs}</p>}
          </div>
        );
      })}
    </div>
  </div>
);

export const FilaEstadoPDF = ({ label, estado, opciones }) => (
  <div className="flex items-center justify-between px-3 py-2 gap-2">
    <span className="text-sm text-gray-700 flex-1">{label}</span>
    <span className={`text-xs font-semibold px-2 py-1 rounded-full whitespace-nowrap ${BADGE_COLOR_PDF[estado] || "bg-gray-100 text-gray-500"}`}>{estado || (opciones ? opciones[opciones.length - 1] : "—")}</span>
  </div>
);

export const FirmaPDF = ({ dataUrl }) => (
  <div className="border rounded-lg p-3">
    <p className="text-xs font-semibold text-gray-500 uppercase mb-2">Firma</p>
    {dataUrl ? <img src={dataUrl} alt="Firma" className="w-full h-28 object-contain bg-gray-50 border rounded" /> : <p className="text-xs text-gray-400">Sin firma</p>}
  </div>
);

// ── Modal de bloqueo por cuota de descargas (plan FREE) ───────────
export const ModalCuotaFree = ({ bloqueo, onClose }) => !bloqueo ? null : (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-xl shadow-xl w-full max-w-sm p-6 space-y-3 text-center">
      <p className="text-2xl">🚫</p>
      <h3 className="font-bold text-gray-800">Límite de descargas alcanzado</h3>
      <p className="text-sm text-gray-500">
        Has alcanzado el límite de 40 descargas este mes.
        {bloqueo.resetDate && <> Se restablece el <strong>{new Date(`${bloqueo.resetDate}T00:00:00`).toLocaleDateString("es-ES")}</strong>.</>}
      </p>
      <button onClick={onClose} className="w-full bg-blue-600 text-white font-bold py-2.5 rounded-xl hover:bg-blue-700 transition-all">Entendido</button>
    </div>
  </div>
);

// ── Modal de aviso genérico (plan FREE) — mismo patrón visual ─────
export const ModalAviso = ({ visible, icono = "ℹ️", titulo, mensaje, onClose }) => !visible ? null : (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-xl shadow-xl w-full max-w-sm p-6 space-y-3 text-center">
      <p className="text-2xl">{icono}</p>
      <h3 className="font-bold text-gray-800">{titulo}</h3>
      <p className="text-sm text-gray-500">{mensaje}</p>
      <button onClick={onClose} className="w-full bg-blue-600 text-white font-bold py-2.5 rounded-xl hover:bg-blue-700 transition-all">Entendido</button>
    </div>
  </div>
);

// ── Pad de firma táctil/ratón, autónomo (mismo mecanismo que MensualForm) ──
export const FirmaCanvas = ({ onChange }) => {
  const canvasRef = useRef(null);
  const [dibujando, setDibujando] = useState(false);
  const [firmada, setFirmada] = useState(false);

  const getPos = (e, canvas) => {
    const rect = canvas.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    return { x: clientX - rect.left, y: clientY - rect.top };
  };

  const empezar = (e) => {
    if (e.touches) e.preventDefault();
    setDibujando(true);
    const ctx = canvasRef.current.getContext("2d");
    const pos = getPos(e, canvasRef.current);
    ctx.beginPath();
    ctx.moveTo(pos.x, pos.y);
  };
  const dibujar = (e) => {
    if (e.touches) e.preventDefault();
    if (!dibujando) return;
    const ctx = canvasRef.current.getContext("2d");
    const pos = getPos(e, canvasRef.current);
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#1e3a5f";
    ctx.lineTo(pos.x, pos.y);
    ctx.stroke();
    if (!firmada) setFirmada(true);
  };
  const terminar = () => {
    setDibujando(false);
    if (firmada) onChange(canvasRef.current.toDataURL());
  };
  const limpiar = () => {
    const canvas = canvasRef.current;
    canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
    setFirmada(false);
    onChange(null);
  };

  return (
    <div className="border rounded-lg p-3 space-y-2">
      <label className="text-xs font-semibold text-gray-600 uppercase">Firma</label>
      <canvas ref={canvasRef} width={400} height={120} className="w-full border rounded bg-gray-50 touch-none" style={{ cursor: "crosshair" }}
        onMouseDown={empezar} onMouseMove={dibujar} onMouseUp={terminar} onMouseLeave={terminar}
        onTouchStart={empezar} onTouchMove={dibujar} onTouchEnd={terminar} />
      <div className="flex justify-between items-center">
        <span className="text-xs text-gray-400">{firmada ? "✅ Firma registrada" : "Firma en el recuadro para continuar"}</span>
        <button onClick={limpiar} className="text-xs text-red-500 underline">Borrar firma</button>
      </div>
    </div>
  );
};
